// Chakra imports
import {
    Box,
    Button,
    Center,
    Flex,
    Image,
    Input,
    SimpleGrid,
    Spacer,
    Stack,
    Text,
    Wrap,
    WrapItem,
    useColorModeValue,
    image,
  } from "@chakra-ui/react";
  // Custom components
  import Card from "components/Card/Card.js";
  import CardBody from "components/Card/CardBody.js";
  import CardHeader from "components/Card/CardHeader.js";
  import React, { useEffect, useState } from "react";
  import { useDispatch, useSelector } from 'react-redux';

  import { useToast } from '@chakra-ui/react'
  import { useParams } from "react-router-dom/cjs/react-router-dom.min";
  import { TRANSPORTINOUT_CLEAR_SNACKBAR } from "constants/types";
  import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
  } from '@chakra-ui/react'
  import { Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react'
import { transportGetById } from "actions/TransportInOutAction";
import axios from 'axios';
import { server_url } from "constants/types";
import { useHistory } from 'react-router-dom';
  function TransportInOutView() {
    const textColor = useColorModeValue("gray.700", "white");
    const borderColor = useColorModeValue("gray.200", "gray.600");

    const [vehicleNumber, setVehicleNumber] = useState("");
    const [type, setType] = useState("");
    const [driverName, setDriverName] = useState('');
    const [driverNumber, setDriverNumber] = useState('');
    const [driverBloodGroup, setDriverBloodGroup] = useState('');
    const [driverImage, setDriverImage] = useState('');
    const [inDateTime, setInDateTime] = useState("");
    const [outDateTime, setOutDateTime] = useState("");
    const [totalTime, setTotalTime] = useState("");
    const [shiftSlots, setShiftSlots] = useState("");
    const [txnNumber, setTxnNumber] = useState("");
    const [transportLog, setTransportLog] = useState([]);
    const [kilometers, setKilometers] = useState("");
   
    const dispatch = useDispatch();
    const toast = useToast();
    const history = useHistory();
    const statuses = ['success', 'error', 'warning', 'info'];
    const responseStatus = useSelector(state => state.TransportInOut.status);
    const responseMessage = useSelector(state => state.TransportInOut.text);
    const loading = useSelector(state => state.TransportInOut.loading);
    const TransportInOutDetails = useSelector(state => state.TransportInOut.transportInOutDetail);
    const showSnackbar = useSelector(state => state.TransportInOut.showSnackbar);
  
    const params = useParams();
    useEffect(() => {
      if (showSnackbar) {
        if (responseStatus === 'OK' && loading === false) {
          console.log("TransportInOutDetails");
          console.log(TransportInOutDetails);
          setVehicleNumber(TransportInOutDetails.busNo);
          setDriverName(TransportInOutDetails.driver.Name);
          setDriverNumber(TransportInOutDetails.driver.phone);
          setDriverBloodGroup(TransportInOutDetails.driver.bloodGroup);
          setDriverImage(TransportInOutDetails.driver.photo);
          setInDateTime(TransportInOutDetails.inDateTime);
          setOutDateTime(TransportInOutDetails.outDateTime);
          setTotalTime(TransportInOutDetails.totalTime);
          setShiftSlots(TransportInOutDetails.shiftSlots);
          setType(TransportInOutDetails.type)
          setTxnNumber(TransportInOutDetails.txnNumber)
          setTransportLog(TransportInOutDetails?.logs);
          setKilometers(TransportInOutDetails?.kilometers);
         
            
          if (responseMessage !== "") {
            toastFunction(responseMessage, 'success');
          }
        } else if (responseStatus === 'NOK' && loading === false) {
          if (responseMessage !== "") {
            toastFunction(responseMessage, 'error');
          }
        }
      }
  
      dispatch({
        type: TRANSPORTINOUT_CLEAR_SNACKBAR,
        payload: {
          showSnackbar: false,
        }
      })
    }, [loading]);
  
    useEffect(() => {
      console.log("params");
      const transportId = params.id;
      const transport = {
        _id : transportId
      };
      dispatch(transportGetById(transport._id));
    }, []);
    useEffect(() => {
      axios
        .get(`${server_url}/admin/detail`, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
          }
        }).then((responce) => {
          console.log("uadlfdafljadhfoadilf");
        })
        .catch((e) => {
          history.push('/auth/signin');
  
        });
    }, [])
    const toastFunction = (title, status) => {
      toast({
        title: title,
        status: status,
        duration: 3000,
        isClosable: true,
      })
    };

    return (
      <>
      <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
        <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="10px">
          <CardHeader p="6px 0px 22px 0px">
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              Transport
            </Text>
          </CardHeader>
          <CardBody>
            {loading ? <Stack>
              <Skeleton height='20px' />
              <Skeleton height='20px' />
              <Skeleton height='20px' />
            </Stack>
              : TransportInOutDetails?
              (<TableContainer>
                <Table variant='simple'>
                  <Tbody>
                    <Tr>
                      <Td>Date</Td>
                      <Td>{TransportInOutDetails.date}</Td>
                    </Tr>
                    <Tr>
                      <Td>Vehicle Number</Td>
                      <Td>{vehicleNumber}</Td>
                    </Tr>
                   
                    <Tr>
                      <Td>Type</Td>
                      <Td>{type}</Td>
                    </Tr>
                    <Tr>
                      <Td>Driver </Td>
                      <Td>{driverName}</Td>
                    </Tr>
                    <Tr>
                      <Td>Driver Number</Td>
                      <Td>{driverNumber}</Td>
                    </Tr>
                   
                    <Tr>
                      <Td>Driver bloodGroup</Td>
                      <Td>{driverBloodGroup}</Td>
                    </Tr>
                    <Tr>
                      <Td>Driver Image</Td>
                      <Td><Flex direction="column">
                        <Text fontSize="md" color={textColor} fontWeight="bold">
                        <Image
                            boxSize='100px'
                            objectFit='cover'
                            src={driverImage}
                            alt='Dan Abramov'
                          />
                          
                        </Text>
                      </Flex>
                      </Td>
                    </Tr>
                   <Tr>
                      <Td>Time</Td>
                       <Td>
                        {TransportInOutDetails.time}
                       </Td>
                    </Tr>
                    
                    <Tr>
                      <Td>Shift</Td>
                       <Td>
                        {shiftSlots}
                       </Td>
                    </Tr>
                    <Tr>
                      <Td>Txn Number</Td>
                       <Td>
                        {txnNumber}
                       </Td>
                    </Tr>
                    <Tr>
                      <Td>Kilometers</Td>
                       <Td>
                        {kilometers}
                       </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>):null}
          </CardBody>
        </Card>
      </Flex>
      {/* Transport Logs */}
      <Flex direction="column" pt={{ base: "120px", md: "30px" }}>
        <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="10px">
          <CardHeader p="6px 0px 22px 0px">
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              Transport Logs
            </Text>
          </CardHeader>
          <CardBody>
          {loading ? (
            <Stack>
              <Skeleton height="20px" />
              <Skeleton height="20px" />
              <Skeleton height="20px" />
            </Stack>
          ) : TransportInOutDetails ? (
            <TableContainer >
                <Table variant='simple'>
                  <Thead>
                    <Tr>
                      <Th color="white">SL</Th>
                      <Th color="white">Route</Th>
                      <Th color="white">Shift</Th>
                      <Th color="white">Driver</Th>
                      <Th color="white">No. of Person</Th>
                      <Th color="white">Type</Th>
                      <Th color="white">Date & Time</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                   
                    {
                      transportLog.map((row, index, arr) => {

                        return (
                         
                           <Tr>
                            <Td>{index +1}</Td>
                            <Td>{row.routeNumber.name}</Td>
                            <Td>{row.shiftSlots}</Td>
                            <Td>{row.driverName}</Td>
                            <Td>{row.numberOfPersons}</Td>
                            <Td>{row.type}</Td>
                            <Td>{row.createdAtFormatted}</Td>
                          </Tr>
                        );
                      })}
                      
                  
                  
                    
                  
                  </Tbody>
                </Table>
                </TableContainer>
          ) : null}
          </CardBody>
        </Card>
      </Flex>
      </>
    );
  }
  
  export default TransportInOutView;
